export default {"src":"/_next/static/media/notification_icon.762ae837.svg","height":27,"width":28,"blurWidth":0,"blurHeight":0};